import styled from '@mui/system/styled';

export const Img = styled('img')({
  verticalAlign: 'middle',
  display: 'inline-block',
  width: 60,
});
